import { useQuery } from "@tanstack/react-query";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import { AgentServiceAccountSchema } from "../types";
import { z } from "zod";

export function useAgentServiceAccounts(agentId: string) {
  return useQuery({
    queryKey: ["agentServiceAccounts", agentId],
    queryFn: async () => {
      const instance = await getCoreAxiosInstance();
      const { data } = await instance.get(
        `/api/v1/agents/${agentId}/service-accounts`,
      );
      return z.array(AgentServiceAccountSchema).parse(data);
    },
    enabled: !!agentId,
  });
}
